"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySiteSummary = exports.StudySite = exports.StudySiteAdditionalInfo = exports.StudySiteCrfAdditionalInfo = exports.StudySiteCrf = exports.StudySiteEssential = void 0;
class StudySiteEssential {
}
exports.StudySiteEssential = StudySiteEssential;
class StudySiteCrf {
}
exports.StudySiteCrf = StudySiteCrf;
class StudySiteCrfAdditionalInfo {
}
exports.StudySiteCrfAdditionalInfo = StudySiteCrfAdditionalInfo;
class StudySiteAdditionalInfo {
}
exports.StudySiteAdditionalInfo = StudySiteAdditionalInfo;
class StudySite {
}
exports.StudySite = StudySite;
class StudySiteSummary {
}
exports.StudySiteSummary = StudySiteSummary;
//# sourceMappingURL=studySite.js.map